module.exports = __webpack_public_path__ + "img/react-ecommerce1.4deade00.png";